import { useLocation } from "react-router-dom";

export function useIsInRoute(routes: string[]) {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");

  return routes.some(route => pathSegments.includes(route));
}
